var _symbol, _use, _view;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "filters-icon",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.334 4.666V3h7.699v1.666h3.334v14.367h-3.334v1.666H8.334v-1.666H5V4.666h3.334zm6.667 0H9.367v-.633h5.634v.633zM6.035 6.334h12.299V5.7H6.035v.634zm0 11.667h12.299v-.634H6.035v.634zm8.966 1.667H9.367v-.635H15v.635zm-8.333-3.334h-.633V7.367h.633v8.967zm1.032 0h1.05V7.367H7.7v8.967zm3.967 0H9.784V7.367h1.883v8.967zm1.034 0h1.883V7.367h-1.883v8.967zm3.967 0h-1.051V7.367h1.05v8.967zm1.666 0H17.7V7.367h.634v8.967z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filters-icon",
    width: 24,
    height: 24
  })), _view || (_view = /*#__PURE__*/React.createElement("view", {
    id: "filters-icon",
    viewBox: "0 838 24 24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.9db22f3c0df760ec711c22ae90f065d9.svg";
export { ForwardRef as ReactComponent };